import { memo } from "react";
import { Button, Chip } from "@mui/material";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import { useMainContext } from "../../../../../context/useMainContext";

const NotesCell = ({ row }) => {
  const {
    setCurrentNoteInfluencer,
    isGuest,
  } = useMainContext();

  const notes = (() => {
    const notesData = row.internal_reviews?.notes;
    if (!notesData) return [];
    let parsedNotes = [];
    if (typeof notesData === "string") {
      try {
        parsedNotes = JSON.parse(notesData);
      } catch {
        return [];
      }
    } else if (Array.isArray(notesData)) {
      parsedNotes = notesData;
    } else {
      return [];
    }
    // Filter out notes with invalid dates
    return parsedNotes.filter(note => {
      if (!note.createdAt) return false;
      const date = new Date(note.createdAt);
      return !isNaN(date.getTime());
    });
  })();

  return (
    <Button
      variant="outlined"
      size="small"
      onClick={() => setCurrentNoteInfluencer(row)}
      disabled={isGuest}
      fullWidth
      startIcon={
        notes.length > 0 ? (
          <Chip
            label={notes.length}
            size="small"
            sx={{
              height: "15px",
              "& .MuiChip-label": {
                padding: "0 4px",
                fontSize: "12px",
              },
            }}
          />
        ) : (
          <EditOutlinedIcon fontSize="small" sx={{ mb: 0.5 }} />
        )
      }
    >
      {notes.length > 0 ? "View Notes" : "Add Note"}
    </Button>
  );
};

export default memo(NotesCell);
